// source: public_trips.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var annotations_pb = require('./annotations_pb.js');
goog.object.extend(proto, annotations_pb);
var api_pb = require('./api_pb.js');
goog.object.extend(proto, api_pb);
goog.exportSymbol('proto.org.couchers.api.public_trips.CreatePublicTripReq', null, global);
goog.exportSymbol('proto.org.couchers.api.public_trips.GetPublicTripReq', null, global);
goog.exportSymbol('proto.org.couchers.api.public_trips.ListPublicTripsByUserReq', null, global);
goog.exportSymbol('proto.org.couchers.api.public_trips.ListPublicTripsByUserRes', null, global);
goog.exportSymbol('proto.org.couchers.api.public_trips.ListPublicTripsReq', null, global);
goog.exportSymbol('proto.org.couchers.api.public_trips.ListPublicTripsRes', null, global);
goog.exportSymbol('proto.org.couchers.api.public_trips.PublicTrip', null, global);
goog.exportSymbol('proto.org.couchers.api.public_trips.PublicTripStatus', null, global);
goog.exportSymbol('proto.org.couchers.api.public_trips.UpdatePublicTripReq', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.public_trips.PublicTrip = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.public_trips.PublicTrip, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.public_trips.PublicTrip.displayName = 'proto.org.couchers.api.public_trips.PublicTrip';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.public_trips.CreatePublicTripReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.public_trips.CreatePublicTripReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.public_trips.CreatePublicTripReq.displayName = 'proto.org.couchers.api.public_trips.CreatePublicTripReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.public_trips.GetPublicTripReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.public_trips.GetPublicTripReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.public_trips.GetPublicTripReq.displayName = 'proto.org.couchers.api.public_trips.GetPublicTripReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.public_trips.ListPublicTripsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.public_trips.ListPublicTripsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.public_trips.ListPublicTripsReq.displayName = 'proto.org.couchers.api.public_trips.ListPublicTripsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.public_trips.ListPublicTripsRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.couchers.api.public_trips.ListPublicTripsRes.repeatedFields_, null);
};
goog.inherits(proto.org.couchers.api.public_trips.ListPublicTripsRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.public_trips.ListPublicTripsRes.displayName = 'proto.org.couchers.api.public_trips.ListPublicTripsRes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.couchers.api.public_trips.ListPublicTripsByUserReq.repeatedFields_, null);
};
goog.inherits(proto.org.couchers.api.public_trips.ListPublicTripsByUserReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.public_trips.ListPublicTripsByUserReq.displayName = 'proto.org.couchers.api.public_trips.ListPublicTripsByUserReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.couchers.api.public_trips.ListPublicTripsByUserRes.repeatedFields_, null);
};
goog.inherits(proto.org.couchers.api.public_trips.ListPublicTripsByUserRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.public_trips.ListPublicTripsByUserRes.displayName = 'proto.org.couchers.api.public_trips.ListPublicTripsByUserRes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.public_trips.UpdatePublicTripReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.public_trips.UpdatePublicTripReq.displayName = 'proto.org.couchers.api.public_trips.UpdatePublicTripReq';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.public_trips.PublicTrip.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.public_trips.PublicTrip} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.public_trips.PublicTrip.toObject = function(includeInstance, msg) {
  var f, obj = {
    tripId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    user: (f = msg.getUser()) && api_pb.User.toObject(includeInstance, f),
    communityId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    fromDate: jspb.Message.getFieldWithDefault(msg, 4, ""),
    toDate: jspb.Message.getFieldWithDefault(msg, 5, ""),
    description: jspb.Message.getFieldWithDefault(msg, 6, ""),
    status: jspb.Message.getFieldWithDefault(msg, 7, 0),
    created: (f = msg.getCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    communitySlug: jspb.Message.getFieldWithDefault(msg, 9, ""),
    sameGenderOnly: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    offersCount: jspb.Message.getFieldWithDefault(msg, 11, 0),
    communityName: jspb.Message.getFieldWithDefault(msg, 12, ""),
    viewerHostRequestId: jspb.Message.getFieldWithDefault(msg, 13, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.public_trips.PublicTrip}
 */
proto.org.couchers.api.public_trips.PublicTrip.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.public_trips.PublicTrip;
  return proto.org.couchers.api.public_trips.PublicTrip.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.public_trips.PublicTrip} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.public_trips.PublicTrip}
 */
proto.org.couchers.api.public_trips.PublicTrip.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTripId(value);
      break;
    case 2:
      var value = new api_pb.User;
      reader.readMessage(value,api_pb.User.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCommunityId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFromDate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setToDate(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 7:
      var value = /** @type {!proto.org.couchers.api.public_trips.PublicTripStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreated(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCommunitySlug(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSameGenderOnly(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOffersCount(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCommunityName(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setViewerHostRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.public_trips.PublicTrip.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.public_trips.PublicTrip} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.public_trips.PublicTrip.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTripId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      api_pb.User.serializeBinaryToWriter
    );
  }
  f = message.getCommunityId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getFromDate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getToDate();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getCreated();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCommunitySlug();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSameGenderOnly();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getCommunityName();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getViewerHostRequestId();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
};


/**
 * optional int64 trip_id = 1;
 * @return {number}
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.getTripId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.api.public_trips.PublicTrip} returns this
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.setTripId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional org.couchers.api.core.User user = 2;
 * @return {?proto.org.couchers.api.core.User}
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.getUser = function() {
  return /** @type{?proto.org.couchers.api.core.User} */ (
    jspb.Message.getWrapperField(this, api_pb.User, 2));
};


/**
 * @param {?proto.org.couchers.api.core.User|undefined} value
 * @return {!proto.org.couchers.api.public_trips.PublicTrip} returns this
*/
proto.org.couchers.api.public_trips.PublicTrip.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.public_trips.PublicTrip} returns this
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.hasUser = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 community_id = 3;
 * @return {number}
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.getCommunityId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.api.public_trips.PublicTrip} returns this
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.setCommunityId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string from_date = 4;
 * @return {string}
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.getFromDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.public_trips.PublicTrip} returns this
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.setFromDate = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string to_date = 5;
 * @return {string}
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.getToDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.public_trips.PublicTrip} returns this
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.setToDate = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string description = 6;
 * @return {string}
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.public_trips.PublicTrip} returns this
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional PublicTripStatus status = 7;
 * @return {!proto.org.couchers.api.public_trips.PublicTripStatus}
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.getStatus = function() {
  return /** @type {!proto.org.couchers.api.public_trips.PublicTripStatus} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.org.couchers.api.public_trips.PublicTripStatus} value
 * @return {!proto.org.couchers.api.public_trips.PublicTrip} returns this
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp created = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.getCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.couchers.api.public_trips.PublicTrip} returns this
*/
proto.org.couchers.api.public_trips.PublicTrip.prototype.setCreated = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.public_trips.PublicTrip} returns this
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.clearCreated = function() {
  return this.setCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.hasCreated = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string community_slug = 9;
 * @return {string}
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.getCommunitySlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.public_trips.PublicTrip} returns this
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.setCommunitySlug = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool same_gender_only = 10;
 * @return {boolean}
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.getSameGenderOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.couchers.api.public_trips.PublicTrip} returns this
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.setSameGenderOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional int32 offers_count = 11;
 * @return {number}
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.getOffersCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.api.public_trips.PublicTrip} returns this
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.setOffersCount = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.couchers.api.public_trips.PublicTrip} returns this
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.clearOffersCount = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.hasOffersCount = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string community_name = 12;
 * @return {string}
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.getCommunityName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.public_trips.PublicTrip} returns this
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.setCommunityName = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional int64 viewer_host_request_id = 13;
 * @return {number}
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.getViewerHostRequestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.api.public_trips.PublicTrip} returns this
 */
proto.org.couchers.api.public_trips.PublicTrip.prototype.setViewerHostRequestId = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.public_trips.CreatePublicTripReq.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.public_trips.CreatePublicTripReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.public_trips.CreatePublicTripReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.public_trips.CreatePublicTripReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    communityId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    fromDate: jspb.Message.getFieldWithDefault(msg, 2, ""),
    toDate: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    sameGenderOnly: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.public_trips.CreatePublicTripReq}
 */
proto.org.couchers.api.public_trips.CreatePublicTripReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.public_trips.CreatePublicTripReq;
  return proto.org.couchers.api.public_trips.CreatePublicTripReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.public_trips.CreatePublicTripReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.public_trips.CreatePublicTripReq}
 */
proto.org.couchers.api.public_trips.CreatePublicTripReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCommunityId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFromDate(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setToDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSameGenderOnly(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.public_trips.CreatePublicTripReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.public_trips.CreatePublicTripReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.public_trips.CreatePublicTripReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.public_trips.CreatePublicTripReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommunityId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getFromDate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getToDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSameGenderOnly();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional int64 community_id = 1;
 * @return {number}
 */
proto.org.couchers.api.public_trips.CreatePublicTripReq.prototype.getCommunityId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.api.public_trips.CreatePublicTripReq} returns this
 */
proto.org.couchers.api.public_trips.CreatePublicTripReq.prototype.setCommunityId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string from_date = 2;
 * @return {string}
 */
proto.org.couchers.api.public_trips.CreatePublicTripReq.prototype.getFromDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.public_trips.CreatePublicTripReq} returns this
 */
proto.org.couchers.api.public_trips.CreatePublicTripReq.prototype.setFromDate = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string to_date = 3;
 * @return {string}
 */
proto.org.couchers.api.public_trips.CreatePublicTripReq.prototype.getToDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.public_trips.CreatePublicTripReq} returns this
 */
proto.org.couchers.api.public_trips.CreatePublicTripReq.prototype.setToDate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.org.couchers.api.public_trips.CreatePublicTripReq.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.public_trips.CreatePublicTripReq} returns this
 */
proto.org.couchers.api.public_trips.CreatePublicTripReq.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool same_gender_only = 5;
 * @return {boolean}
 */
proto.org.couchers.api.public_trips.CreatePublicTripReq.prototype.getSameGenderOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.couchers.api.public_trips.CreatePublicTripReq} returns this
 */
proto.org.couchers.api.public_trips.CreatePublicTripReq.prototype.setSameGenderOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.public_trips.GetPublicTripReq.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.public_trips.GetPublicTripReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.public_trips.GetPublicTripReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.public_trips.GetPublicTripReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    tripId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.public_trips.GetPublicTripReq}
 */
proto.org.couchers.api.public_trips.GetPublicTripReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.public_trips.GetPublicTripReq;
  return proto.org.couchers.api.public_trips.GetPublicTripReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.public_trips.GetPublicTripReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.public_trips.GetPublicTripReq}
 */
proto.org.couchers.api.public_trips.GetPublicTripReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTripId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.public_trips.GetPublicTripReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.public_trips.GetPublicTripReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.public_trips.GetPublicTripReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.public_trips.GetPublicTripReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTripId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 trip_id = 1;
 * @return {number}
 */
proto.org.couchers.api.public_trips.GetPublicTripReq.prototype.getTripId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.api.public_trips.GetPublicTripReq} returns this
 */
proto.org.couchers.api.public_trips.GetPublicTripReq.prototype.setTripId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.public_trips.ListPublicTripsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.public_trips.ListPublicTripsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.public_trips.ListPublicTripsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.public_trips.ListPublicTripsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    communityId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pageSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageToken: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.public_trips.ListPublicTripsReq}
 */
proto.org.couchers.api.public_trips.ListPublicTripsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.public_trips.ListPublicTripsReq;
  return proto.org.couchers.api.public_trips.ListPublicTripsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.public_trips.ListPublicTripsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.public_trips.ListPublicTripsReq}
 */
proto.org.couchers.api.public_trips.ListPublicTripsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCommunityId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.public_trips.ListPublicTripsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.public_trips.ListPublicTripsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.public_trips.ListPublicTripsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.public_trips.ListPublicTripsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommunityId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int64 community_id = 1;
 * @return {number}
 */
proto.org.couchers.api.public_trips.ListPublicTripsReq.prototype.getCommunityId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.api.public_trips.ListPublicTripsReq} returns this
 */
proto.org.couchers.api.public_trips.ListPublicTripsReq.prototype.setCommunityId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 page_size = 2;
 * @return {number}
 */
proto.org.couchers.api.public_trips.ListPublicTripsReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.api.public_trips.ListPublicTripsReq} returns this
 */
proto.org.couchers.api.public_trips.ListPublicTripsReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string page_token = 3;
 * @return {string}
 */
proto.org.couchers.api.public_trips.ListPublicTripsReq.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.public_trips.ListPublicTripsReq} returns this
 */
proto.org.couchers.api.public_trips.ListPublicTripsReq.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.couchers.api.public_trips.ListPublicTripsRes.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.public_trips.ListPublicTripsRes.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.public_trips.ListPublicTripsRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.public_trips.ListPublicTripsRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.public_trips.ListPublicTripsRes.toObject = function(includeInstance, msg) {
  var f, obj = {
    publicTripsList: jspb.Message.toObjectList(msg.getPublicTripsList(),
    proto.org.couchers.api.public_trips.PublicTrip.toObject, includeInstance),
    nextPageToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.public_trips.ListPublicTripsRes}
 */
proto.org.couchers.api.public_trips.ListPublicTripsRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.public_trips.ListPublicTripsRes;
  return proto.org.couchers.api.public_trips.ListPublicTripsRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.public_trips.ListPublicTripsRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.public_trips.ListPublicTripsRes}
 */
proto.org.couchers.api.public_trips.ListPublicTripsRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.couchers.api.public_trips.PublicTrip;
      reader.readMessage(value,proto.org.couchers.api.public_trips.PublicTrip.deserializeBinaryFromReader);
      msg.addPublicTrips(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.public_trips.ListPublicTripsRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.public_trips.ListPublicTripsRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.public_trips.ListPublicTripsRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.public_trips.ListPublicTripsRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPublicTripsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.couchers.api.public_trips.PublicTrip.serializeBinaryToWriter
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated PublicTrip public_trips = 1;
 * @return {!Array<!proto.org.couchers.api.public_trips.PublicTrip>}
 */
proto.org.couchers.api.public_trips.ListPublicTripsRes.prototype.getPublicTripsList = function() {
  return /** @type{!Array<!proto.org.couchers.api.public_trips.PublicTrip>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.couchers.api.public_trips.PublicTrip, 1));
};


/**
 * @param {!Array<!proto.org.couchers.api.public_trips.PublicTrip>} value
 * @return {!proto.org.couchers.api.public_trips.ListPublicTripsRes} returns this
*/
proto.org.couchers.api.public_trips.ListPublicTripsRes.prototype.setPublicTripsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.couchers.api.public_trips.PublicTrip=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.couchers.api.public_trips.PublicTrip}
 */
proto.org.couchers.api.public_trips.ListPublicTripsRes.prototype.addPublicTrips = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.couchers.api.public_trips.PublicTrip, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.couchers.api.public_trips.ListPublicTripsRes} returns this
 */
proto.org.couchers.api.public_trips.ListPublicTripsRes.prototype.clearPublicTripsList = function() {
  return this.setPublicTripsList([]);
};


/**
 * optional string next_page_token = 2;
 * @return {string}
 */
proto.org.couchers.api.public_trips.ListPublicTripsRes.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.public_trips.ListPublicTripsRes} returns this
 */
proto.org.couchers.api.public_trips.ListPublicTripsRes.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserReq.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserReq.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.public_trips.ListPublicTripsByUserReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.public_trips.ListPublicTripsByUserReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pageSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageToken: jspb.Message.getFieldWithDefault(msg, 3, ""),
    statusesInList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    ascending: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.public_trips.ListPublicTripsByUserReq}
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.public_trips.ListPublicTripsByUserReq;
  return proto.org.couchers.api.public_trips.ListPublicTripsByUserReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.public_trips.ListPublicTripsByUserReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.public_trips.ListPublicTripsByUserReq}
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    case 4:
      var values = /** @type {!Array<!proto.org.couchers.api.public_trips.PublicTripStatus>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addStatusesIn(values[i]);
      }
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAscending(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.public_trips.ListPublicTripsByUserReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.public_trips.ListPublicTripsByUserReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStatusesInList();
  if (f.length > 0) {
    writer.writePackedEnum(
      4,
      f
    );
  }
  f = message.getAscending();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional int64 user_id = 1;
 * @return {number}
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserReq.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.api.public_trips.ListPublicTripsByUserReq} returns this
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 page_size = 2;
 * @return {number}
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.api.public_trips.ListPublicTripsByUserReq} returns this
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string page_token = 3;
 * @return {string}
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserReq.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.public_trips.ListPublicTripsByUserReq} returns this
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserReq.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated PublicTripStatus statuses_in = 4;
 * @return {!Array<!proto.org.couchers.api.public_trips.PublicTripStatus>}
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserReq.prototype.getStatusesInList = function() {
  return /** @type {!Array<!proto.org.couchers.api.public_trips.PublicTripStatus>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<!proto.org.couchers.api.public_trips.PublicTripStatus>} value
 * @return {!proto.org.couchers.api.public_trips.ListPublicTripsByUserReq} returns this
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserReq.prototype.setStatusesInList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {!proto.org.couchers.api.public_trips.PublicTripStatus} value
 * @param {number=} opt_index
 * @return {!proto.org.couchers.api.public_trips.ListPublicTripsByUserReq} returns this
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserReq.prototype.addStatusesIn = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.couchers.api.public_trips.ListPublicTripsByUserReq} returns this
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserReq.prototype.clearStatusesInList = function() {
  return this.setStatusesInList([]);
};


/**
 * optional bool ascending = 5;
 * @return {boolean}
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserReq.prototype.getAscending = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.couchers.api.public_trips.ListPublicTripsByUserReq} returns this
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserReq.prototype.setAscending = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserRes.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserRes.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.public_trips.ListPublicTripsByUserRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.public_trips.ListPublicTripsByUserRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserRes.toObject = function(includeInstance, msg) {
  var f, obj = {
    publicTripsList: jspb.Message.toObjectList(msg.getPublicTripsList(),
    proto.org.couchers.api.public_trips.PublicTrip.toObject, includeInstance),
    nextPageToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.public_trips.ListPublicTripsByUserRes}
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.public_trips.ListPublicTripsByUserRes;
  return proto.org.couchers.api.public_trips.ListPublicTripsByUserRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.public_trips.ListPublicTripsByUserRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.public_trips.ListPublicTripsByUserRes}
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.couchers.api.public_trips.PublicTrip;
      reader.readMessage(value,proto.org.couchers.api.public_trips.PublicTrip.deserializeBinaryFromReader);
      msg.addPublicTrips(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.public_trips.ListPublicTripsByUserRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.public_trips.ListPublicTripsByUserRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPublicTripsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.couchers.api.public_trips.PublicTrip.serializeBinaryToWriter
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated PublicTrip public_trips = 1;
 * @return {!Array<!proto.org.couchers.api.public_trips.PublicTrip>}
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserRes.prototype.getPublicTripsList = function() {
  return /** @type{!Array<!proto.org.couchers.api.public_trips.PublicTrip>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.couchers.api.public_trips.PublicTrip, 1));
};


/**
 * @param {!Array<!proto.org.couchers.api.public_trips.PublicTrip>} value
 * @return {!proto.org.couchers.api.public_trips.ListPublicTripsByUserRes} returns this
*/
proto.org.couchers.api.public_trips.ListPublicTripsByUserRes.prototype.setPublicTripsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.couchers.api.public_trips.PublicTrip=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.couchers.api.public_trips.PublicTrip}
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserRes.prototype.addPublicTrips = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.couchers.api.public_trips.PublicTrip, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.couchers.api.public_trips.ListPublicTripsByUserRes} returns this
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserRes.prototype.clearPublicTripsList = function() {
  return this.setPublicTripsList([]);
};


/**
 * optional string next_page_token = 2;
 * @return {string}
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserRes.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.public_trips.ListPublicTripsByUserRes} returns this
 */
proto.org.couchers.api.public_trips.ListPublicTripsByUserRes.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.public_trips.UpdatePublicTripReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.public_trips.UpdatePublicTripReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    tripId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    fromDate: jspb.Message.getFieldWithDefault(msg, 2, ""),
    toDate: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    status: jspb.Message.getFieldWithDefault(msg, 5, 0),
    sameGenderOnly: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.public_trips.UpdatePublicTripReq}
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.public_trips.UpdatePublicTripReq;
  return proto.org.couchers.api.public_trips.UpdatePublicTripReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.public_trips.UpdatePublicTripReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.public_trips.UpdatePublicTripReq}
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTripId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFromDate(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setToDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {!proto.org.couchers.api.public_trips.PublicTripStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSameGenderOnly(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.public_trips.UpdatePublicTripReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.public_trips.UpdatePublicTripReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTripId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {!proto.org.couchers.api.public_trips.PublicTripStatus} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional int64 trip_id = 1;
 * @return {number}
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.prototype.getTripId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.api.public_trips.UpdatePublicTripReq} returns this
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.prototype.setTripId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string from_date = 2;
 * @return {string}
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.prototype.getFromDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.public_trips.UpdatePublicTripReq} returns this
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.prototype.setFromDate = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.couchers.api.public_trips.UpdatePublicTripReq} returns this
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.prototype.clearFromDate = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.prototype.hasFromDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string to_date = 3;
 * @return {string}
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.prototype.getToDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.public_trips.UpdatePublicTripReq} returns this
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.prototype.setToDate = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.couchers.api.public_trips.UpdatePublicTripReq} returns this
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.prototype.clearToDate = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.prototype.hasToDate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.public_trips.UpdatePublicTripReq} returns this
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.prototype.setDescription = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.couchers.api.public_trips.UpdatePublicTripReq} returns this
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.prototype.clearDescription = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.prototype.hasDescription = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional PublicTripStatus status = 5;
 * @return {!proto.org.couchers.api.public_trips.PublicTripStatus}
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.prototype.getStatus = function() {
  return /** @type {!proto.org.couchers.api.public_trips.PublicTripStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.org.couchers.api.public_trips.PublicTripStatus} value
 * @return {!proto.org.couchers.api.public_trips.UpdatePublicTripReq} returns this
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.prototype.setStatus = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.couchers.api.public_trips.UpdatePublicTripReq} returns this
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.prototype.clearStatus = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool same_gender_only = 6;
 * @return {boolean}
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.prototype.getSameGenderOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.couchers.api.public_trips.UpdatePublicTripReq} returns this
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.prototype.setSameGenderOnly = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.couchers.api.public_trips.UpdatePublicTripReq} returns this
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.prototype.clearSameGenderOnly = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.public_trips.UpdatePublicTripReq.prototype.hasSameGenderOnly = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * @enum {number}
 */
proto.org.couchers.api.public_trips.PublicTripStatus = {
  PUBLIC_TRIP_STATUS_UNSPECIFIED: 0,
  PUBLIC_TRIP_STATUS_SEARCHING_FOR_HOST: 1,
  PUBLIC_TRIP_STATUS_CLOSED: 2
};

goog.object.extend(exports, proto.org.couchers.api.public_trips);
